module.exports = __webpack_public_path__ + "img/Group 1504775756.2b92ad37.svg";